
import { defineComponent } from "vue";

export default defineComponent({
    name: "Dropdown",
    props: {
        dropdownItems: {},
        selectedAlgo: {
            type: String,
        },
    },
    methods: {
        emitAndHide(item: string) {
            this.$emit("selectionChanged", item);
        },
    },
});
